module.exports = __webpack_public_path__ + "img/btn3.0655555f.png";